const THEME_KEY = 'codeshore-theme';

const getPreferredTheme = () => {
    const savedTheme = localStorage.getItem(THEME_KEY);
    if (savedTheme === 'light' || savedTheme === 'dark') {
        return savedTheme;
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const applyTheme = (theme) => {
    const nextTheme = theme === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', nextTheme);
    document.body?.setAttribute('data-theme', nextTheme);
    document.body?.classList.toggle('theme-dark', nextTheme === 'dark');
    document.body?.classList.toggle('theme-light', nextTheme === 'light');
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
        button.setAttribute('aria-pressed', nextTheme === 'dark' ? 'true' : 'false');
        const label = button.querySelector('[data-theme-label]');
        if (label) {
            label.textContent = nextTheme === 'dark' ? 'Light mode' : 'Dark mode';
        }
    });
};

const initializeTheme = () => {
    applyTheme(getPreferredTheme());

    document.addEventListener('click', (event) => {
        const toggle = event.target.closest('[data-theme-toggle]');
        if (!toggle) {
            return;
        }

        const currentTheme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
        const nextTheme = currentTheme === 'dark' ? 'light' : 'dark';
        localStorage.setItem(THEME_KEY, nextTheme);
        applyTheme(nextTheme);
    });

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
        if (localStorage.getItem(THEME_KEY)) {
            return;
        }

        applyTheme(event.matches ? 'dark' : 'light');
    });
};

initializeTheme();
